import wx from "weixin-js-sdk";
import { getJsSdk } from "@/api/product";

const weiXinConfig = async () => {
  const { data } = await getJsSdk();
  const { appId, timestamp, nonceStr, signature } = data.data;
  wx.config({
    debug: false,
    appId: appId,
    timestamp: timestamp,
    nonceStr: nonceStr,
    signature: signature,
    jsApiList: [
      "scanQRCode",
      "checkJsApi",
      // "previewImage",
      // "updateTimelineShareData",
      // "updateAppMessageShareData",
      // "onMenuShareTimeline",
      // "onMenuShareAppMessage",
      // "hideAllNonBaseMenuItem",
      // "showAllNonBaseMenuItem",
    ], // 需要使用的JS接口列表
    openTagList: ["wx-open-launch-weapp"],
  });

  wx.checkJsApi({
    jsApiList: ["scanQRCode"],
    openTagList: ["wx-open-launch-weapp"],
    success: function (res) {
      console.log(res);
    },
  });

  wx.ready(function () {
    console.log("config ready");
  });
  wx.error(function (res) {
    console.log("config error", res);
  });
};

// async function wxMenuShare(wxShareSet) {
//   // 通过ready接口处理成功验证
//   await weiXinConfig();
//   wx.ready(() => {
//     wx.updateTimelineShareData(wxShareSet);
//     wx.updateAppMessageShareData(wxShareSet);
//     wx.onMenuShareTimeline(wxShareSet);
//     wx.onMenuShareAppMessage(wxShareSet);
//     wx.showAllNonBaseMenuItem();
//   });
// }

export default weiXinConfig;
// export { wxMenuShare };
